module.exports = __webpack_public_path__ + "img/player 2.b2c9c7d2.png";